export default __webpack_public_path__ + "static/media/background_shadow.8512fc8e.png";